export * from './app-shell-pinned-strip.component';
